import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; // <-- Corrección de la librería oficial

const firebaseConfig = {
  apiKey: "AIzaSyDuvru-qeVjMoHIpijZPJMvv9MixaUIY1c",
  authDomain: "mitico-tienda.firebaseapp.com",
  projectId: "mitico-tienda",
  storageBucket: "mitico-tienda.firebasestorage.app",
  messagingSenderId: "544796179255",
  appId: "1:544796179255:web:50baeef48805e9dd9db8b2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Inicializar la base de datos de Firestore
// 2. Aquí está la clave: ambas líneas deben tener el 'export' al principio
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app); // <-- Exportamos la conexión a Auth
